// Translates 5 floating images from scattered offsets to 0,0 as the user scrolls
// through the section. Also pulses the content at the midpoint.
// Mirrors Webflow's "Layout 425 [Scroll] [Desktop]" IX2 action (a-18).
export default function initWhyProvidence() {
    const section = document.querySelector('[data-why-providence]');
    if (!section) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(max-width: 767px)').matches) return;

    const content = section.querySelector('[data-why-content]');
    const images = section.querySelectorAll('[data-image]');
    if (!images.length) return;

    // Starting offsets (at scroll progress 0) mapping from IX2 keyframe 0
    const starts = {
        1: { x:  90, y:  70 },
        2: { x:  90, y: -50 },
        3: { x:  10, y: -130 },
        4: { x: -80, y:  60 },
        5: { x: -60, y: -60 },
    };
    // Final offsets land at 0,0 by keyframe 35
    const FINAL_KEYFRAME = 0.35;
    // Content dip: scale 0.95 + opacity 0 at 15%, back to 1/1 at 30%
    const DIP_IN = 0.15;
    const DIP_OUT = 0.30;

    let ticking = false;

    const lerp = (a, b, t) => a + (b - a) * t;

    const update = () => {
        ticking = false;
        const rect = section.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        // Progress begins only once the section top has reached the viewport top
        // (when the inner wrapper becomes sticky). It completes when the section
        // has scrolled its full sticky range (rect.height - vh).
        const scrollable = Math.max(1, rect.height - vh);
        const raw = Math.min(1, Math.max(0, -rect.top / scrollable));

        // Map overall progress into the 0→FINAL_KEYFRAME phase for image transforms
        const imgT = Math.min(1, raw / FINAL_KEYFRAME);
        images.forEach((el) => {
            const id = el.getAttribute('data-image');
            const s = starts[id];
            if (!s) return;
            const x = lerp(s.x, 0, imgT);
            const y = lerp(s.y, 0, imgT);
            el.style.transform = `translate3d(${x}%, ${y}%, 0)`;
        });

        // Content pulse
        if (content) {
            let opacity = 1, scale = 1;
            if (raw >= DIP_IN && raw <= DIP_OUT) {
                const dipProgress = (raw - DIP_IN) / (DIP_OUT - DIP_IN);
                // Parabola: dips at the midpoint
                const dip = 1 - Math.abs(dipProgress * 2 - 1);
                opacity = 1 - dip;
                scale = 1 - dip * 0.05;
            }
            content.style.opacity = opacity.toFixed(3);
            content.style.transform = `scale(${scale.toFixed(3)})`;
        }
    };

    const onScroll = () => {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
}
